import React from 'react';
import './Footer.css'

const Footer= () => {
    return (
        <div className="footerWrapper">
            <p>&copy; 2020 coded : <a href="http://maximilianlau.com" target="_blank" rel="noopener noreferrer" tabIndex='0'>Maximilian Lau</a> using clarifai</p>
        </div>
    )
}

export default Footer;